import moment from 'moment';

//TODO pregledaj sortiranje kod određenih poziva, negdje su prilagođene staroj strukturi podataka, npr. task.task
export function approverSorter(a, b) {
    let aSurname = a.split(" ")[1];
    let bSurname = b.split(" ")[1];

    if (aSurname && bSurname && aSurname.localeCompare(bSurname) !== 0)
        return aSurname.localeCompare(bSurname);

    let aName = a.split(" ")[0];
    let bName = b.split(" ")[0];

    if (aName && bName && aName.localeCompare(bName) !== 0)
        return aName.localeCompare(bName);

    return 1;
}

export function logEntrySorter(a, b) {
    // it's a timer pill, it goes down regardless of start time
    if (a.timer) return 1;
    if (b.timer) return -1;

    // if both have the same start time or if one or both are null put the older one first
    if ((a.startTime === b.startTime) || (!a.startTime && !b.startTime))
        if (a.id < b.id)
            return -1;

    if (!a.startTime) return 1;
    if (!b.startTime) return -1;

    // rest is sorted by start time
    if (Date.parse("01/01/2015 " + a.startTime) < Date.parse("01/01/2015 " + b.startTime))
        return -1;

    return 1;
}

export function customerGroupProjectSorter(a, b) {
    if (a.year < b.year)
        return -1;

    return 1;
}

export function notificationSorter(a, b) {
    let t1 = moment(a.timestamp, "YYYY-MM-DD[T]H:mm:ss.SSS");
    let t2 = moment(b.timestamp, "YYYY-MM-DD[T]H:mm:ss.SSS");

    if (t1.isBefore(t2)) return 1;

    return -1;
}

export function timesheetSorter(a, b) {
    let aSurname = a.usersName.split(" ")[1];
    let bSurname = b.usersName.split(" ")[1];

    if (aSurname.localeCompare(bSurname) !== 0)
        return aSurname.localeCompare(bSurname);

    return a.usersName.localeCompare(b.usersName);
}

export function userTaskSorter(a, b) {
    if (!a.taskClosed && b.taskClosed) return -1;

    if (a.taskClosed && !b.taskClosed) return 1;

    if (!a.taskName) return 1;

    if (!b.taskName) return -1;

    return a.taskName.localeCompare(b.taskName);
}

export function weekSorter(a, b) {
    let momentA = moment(a);
    let momentB = moment(b);

    if (momentA.isBefore(momentB)) return -1;

    return 1;
}

export function getFloatingTaskSorter(currentUser) {
    return (a, b) => {
        if (a.managerID === currentUser.id && (!b.managerID || b.managerID !== currentUser.id))
            return -1;

        if (b.managerID === currentUser.id && (!a.managerID || a.managerID !== currentUser.id))
            return 1;

        if (!a.managerID && b.managerID) return -1;

        if (a.managerID && !b.managerID) return 1;

        if (a.managerName && b.managerName) {
            let aSurname = a.managerName.split(" ")[1];
            let bSurname = b.managerName.split(" ")[1];
            if (aSurname.localeCompare(bSurname) !== 0)
                return aSurname.localeCompare(bSurname);

            let aName = a.managerName.split(" ")[0];
            let bName = b.managerName.split(" ")[0];

            if (aName.localeCompare(bName) !== 0)
                return aName.localeCompare(bName);
        }

        let aCreatorSurname = a.createdBy.split(" ")[1];
        let bCreatorSurname = b.createdBy.split(" ")[1];

        if (aCreatorSurname.toLowerCase().localeCompare(bCreatorSurname.toLowerCase()) !== 0)
            return aCreatorSurname.toLowerCase().localeCompare(bCreatorSurname.toLowerCase());

        let aCreatorName = a.createdBy.split(" ")[0];
        let bCreatorName = b.createdBy.split(" ")[0];

        if (aCreatorName.toLowerCase().localeCompare(bCreatorName.toLowerCase()) !== 0)
            return aCreatorName.toLowerCase().localeCompare(bCreatorName.toLowerCase());
    };
}

export function getManagerNameSorter(currentUserName) {
    return (a, b) => {
        if (a === currentUserName && b !== currentUserName) return -1;

        if (a !== currentUserName && b === currentUserName) return 1;

        if (a === "Unassigned" && b !== "Unassigned") return -1;

        if (a !== "Unassigned" && b === "Unassigned") return 1;

        let aSurname = a.split(" ")[1];
        let bSurname = b.split(" ")[1];

        if (aSurname.localeCompare(bSurname) !== 0) return aSurname.localeCompare(bSurname);

        let aName = a.split(" ")[0];
        let bName = b.split(" ")[0];

        return aName.localeCompare(bName);
    };
}

export function getProjectNameSorter(projectsMap) {
    return (a, b) => {
        if (!projectsMap[a].projectArchived && projectsMap[b].projectArchived)
            return -1;

        if (projectsMap[a].projectArchived && !projectsMap[b].projectArchived)
            return 1;

        return a.localeCompare(b);
    };
}

export function sortByName(a, b) {
    if (a.name.localeCompare(b.name) !== 0)
        return a.name.localeCompare(b.name);
}

export function sortByDate(a, b) {
    if (moment(a.date).isBefore(moment(b.date)))
        return 1;
    else if (moment(a.date).isAfter(moment(b.date)))
        return -1;
}

export function sortTasksByProjectAndTaskName(a, b) {
    //check if task is floating
    if (a.projectName)
        if (a.projectName.localeCompare(b.projectName) !== 0)
            return a.projectName.localeCompare(b.projectName);

    if (a.name.localeCompare(b.name) !== 0)
        return a.name.localeCompare(b.name);
}

export function sortUsersByName(a, b) {
    if (a.surname.localeCompare(b.surname) !== 0)
        return a.surname.localeCompare(b.surname);

    if (a.givenName.localeCompare(b.givenName) !== 0)
        return a.givenName.localeCompare(b.givenName);

    return a.id - b.id;
}
// TODO analiziraj koja je funkcija bolja pa ju primjeni svugdje
export function sortUsersByName2(a, b) {
    if (a.surname < b.surname) return -1;

    if (b.surname < a.surname) return 1;

    if (a.givenName < b.givenName) return -1;

    if (b.givenName < a.givenName) return 1;

    return b.id - a.id;
}

export function sortUsersByName3(a, b) {
    if (a.surname.toLowerCase().localeCompare(b.surname.toLowerCase()))
        return a.surname.toLowerCase().localeCompare(b.surname.toLowerCase());

    return a.givenName.toLowerCase().localeCompare(b.givenName.toLowerCase());
}

export function sortUserTasksByUserName(a, b) {

    if (a.usersName && b.usersName) {
        let aSurname = a.usersName.split(" ")[1];
        let bSurname = b.usersName.split(" ")[1];

        if (aSurname.toLowerCase().localeCompare(bSurname.toLowerCase()) !== 0)
        return aSurname.toLowerCase().localeCompare(bSurname.toLowerCase());

        return a.usersName.toLowerCase().localeCompare(b.usersName.toLowerCase());
    } else {
        return true;
    }

}

export function createNewSortedLogEntryArray(originalLogEntries) {
    let logEntries = [];

    originalLogEntries.map(logEntry => logEntries.push(logEntry));

    logEntries.sort(logEntrySorter);

    return logEntries;
}



/** WEBPACK FOOTER **
 ** ./src/app/utils/sorting.js
 **/